// extracted by mini-css-extract-plugin
export default {"sidebar":"FZzEY","sidebar--wider":"UUFSP","sidebar--widest":"XSB10","sidebar--no-close-button":"WKEV9","close-button":"Oz5W8","footer":"TSYKp"};